export class MechanicsConfig {
    public static mechanics = {
        fill_bar: 'fill_bar',
        background_release: 'background_release',
        drop_elements: 'drop_elements' 
    }
}